/**
 * 달력 공용 헬퍼 — 홈 주문 달력과 주문서 희망 배송일 달력이 같이 쓴다.
 * 날짜 문자열은 로컬 기준 YYYY-MM-DD(주문 desiredDate 형식)라 문자열 비교로 과거/미래를 가른다.
 */

export const DOW = ['일', '월', '화', '수', '목', '금', '토']

/** 로컬 기준 YYYY-MM-DD. */
export function localDateStr(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

/** 'YYYY-MM-DD' → 로컬 자정 Date. */
export function parseLocalDate(v: string): Date {
  const [y, m, d] = v.split('-').map(Number)
  return new Date(y!, (m ?? 1) - 1, d ?? 1)
}

/** 달력 그리드가 시작하는 일요일(그 달 1일이 속한 주의 일요일). */
export function gridStartOf(month: Date): Date {
  const first = new Date(month.getFullYear(), month.getMonth(), 1)
  const start = new Date(first)
  start.setDate(1 - first.getDay())
  return start
}

/** 달력 그리드 6주(42칸). 앞뒤 인접월 날짜까지 채워 높이를 고정한다. */
export function buildCells(start: Date): Date[] {
  return Array.from({ length: 42 }, (_, i) => {
    const d = new Date(start)
    d.setDate(start.getDate() + i)
    return d
  })
}
